import React from 'react'
import { useLocation, useParams } from 'react-router-dom'
import Breadcrum from '../../components/breadcrum'
import AddInsight from '../../components/AddInsight'
import {
  createFunding,
  getCompanyById,
  getSingleReportById,
  updateFunding,
} from '../../api/fundingApi'

const AddFundingReport = () => {
  const { companyId, id } = useParams()
  const location = useLocation()

  const isEdit = !!location.pathname.includes('edit')

  return (
    <>
      <Breadcrum
        heading="Insight"
        subheading={isEdit ? 'Edit funding365' : 'Add funding365'}
      />
      <AddInsight
        insightId={id}
        fundingCompanyId={companyId}
        isEdit={isEdit}
        insightType="funding365"
        apiConfig={{
          createFn: createFunding,
          updateFn: updateFunding,
          getFn: getSingleReportById,
          companyGetFn: getCompanyById,
        }}
      />
    </>
  )
}

export default AddFundingReport
